import Quill from 'quill';

export const TEXT_SIZES = [
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '24px',
  '32px',
  '36px',
  '48px',
  '60px',
  '72px',
];

const Size = Quill.import('attributors/style/size');

Size.whitelist = TEXT_SIZES;
Quill.register(Size, true);

const Delta = Quill.import('delta');

function nearestTextSize(px) {
  return TEXT_SIZES.reduce((closest, size) =>
    Math.abs(parseInt(size, 10) - px) < Math.abs(parseInt(closest, 10) - px) ? size : closest,
  );
}

function pxFromCssLength(value) {
  const probe = document.createElement('span');
  probe.style.cssText = 'position:absolute; visibility:hidden;';
  probe.style.fontSize = value;
  document.body.appendChild(probe);
  const px = parseFloat(window.getComputedStyle(probe).fontSize);
  probe.remove();
  return Number.isNaN(px) ? null : px;
}

function matchPastedFontSize(node, delta, scroll) {
  if (!scroll.query('size')) return delta;
  const raw = node.style?.fontSize;
  if (!raw) return delta;
  const px = pxFromCssLength(raw);
  if (px == null) return delta;
  const size = nearestTextSize(px);
  return delta.reduce((newDelta, op) => {
    if (!op.insert) return newDelta;
    if (op.attributes?.size) return newDelta.push(op);
    return newDelta.insert(op.insert, { size, ...op.attributes });
  }, new Delta());
}

export const EDITOR_MODULES = {
  clipboard: {
    matchers: [[window.Node.ELEMENT_NODE, matchPastedFontSize]],
  },
};

const CARRY_FORMATS = ['size', 'bold', 'italic', 'underline', 'strike', 'color', 'background'];

export function persistFormatAcrossNewline(quill) {
  quill.on('text-change', (delta, _oldContents, source) => {
    if (source !== 'user') return;
    const last = delta.ops[delta.ops.length - 1];
    if (!last || last.insert !== '\n') return;
    setTimeout(() => {
      const selection = quill.getSelection();
      if (!selection || selection.index < 2) return;
      const prevFormat = quill.getFormat(selection.index - 2, 1);
      CARRY_FORMATS.forEach((name) => {
        if (prevFormat[name]) quill.format(name, prevFormat[name], 'user');
      });
    }, 0);
  });
}
